module.exports = __webpack_public_path__ + "static/media/default_channel_icon.4ffd7807.png";